import config from "@/config"
import http from "@/utils/request"
//
export default {
  // this.pageName 当前组件的名字
  list: {
    name: "获取table列表数据",
    get: async function (params) {
      console.log("params", params)
      const url = `${config.API_URL}/${this.prefix}/${this.pageName}/list`
      params = {
        ...params,
        tenantId: "257613"
      }
      return await http.get(url, params)
    }
  },
  // 虚拟列表数据请求
  vlist: {
    name: "获取虚拟列表数据",
    get: async function (params, pageName, prefix) {
      const url = `${config.API_URL}/${prefix}/${pageName}/list`
      params = {
        ...params
      }
      return await http.get(url, params)
    }
  },
  // pageName config传入的pageName
  post: {
    name: "新增或编辑数据",
    post: async function (data, pageName, prefix) {
      const url = `${config.API_URL}/${prefix}/${pageName}/submit`
      data = {
        ...data,
        tenantId: "257613"
      }
      return await http.post(url, data)
    }
  },
  del: {
    name: "删除数据",
    post: async function (params, pageName, prefix) {
      const url = `${config.API_URL}/${prefix}/${pageName}/remove`
      return await http.post(url, null, { params })
    }
  }
}
